export enum ErrorTypes {
    InternalError = '0000',
    ClientNotFound = '0019'
}